import { BlogSection } from '@/types/blog';

export const worteSchoepfungSection: BlogSection = {
  id: 'worte-schoepfung',
  title: 'Worte sind Schöpfung',
  content: `
    <p>
      Ein Zitat aus buddhistischer Tradition besagt: „Achte auf deine Gedanken, denn sie werden Worte. Achte auf deine Worte, denn sie werden Taten. Und aus deinen Taten entsteht dein Wesen." Wenn wir begreifen, dass Kommunikation nicht nur Austausch ist, sondern Weltformung, verändert sich alles. Jeder Tweet, jede Überschrift, jeder Kommentar wird zu einem Ausdruck dessen, wie wir die Welt gestalten – bewusst oder unbewusst, verletzend oder verbindend.
    </p>
  `
};
